import { createReducer } from '@reduxjs/toolkit';

import postEasyShipBuyShipment from '../../../thunks/shipment/easyShip/postEasyShipBuyShipment';
import postEasyShipShipmentClearState from '../../../actions/shipment/easyShip/postEasyShipBuyShipment';

const initialState = {
  loading: false,
  error: null,
  data: undefined,
};

const postEasyShipBuyShipmentReducer = createReducer(initialState, {
  [postEasyShipBuyShipment.pending]: (state) => ({
    ...state,
    loading: true,
    error: null,
  }),
  [postEasyShipBuyShipment.fulfilled]: (state, { payload }) => ({
    ...state,
    loading: false,
    data: payload
  }),
  [postEasyShipBuyShipment.rejected]: (state, { payload }) => ({
    ...state,
    loading: false,
    error: payload,
    data: undefined
  }),
  [postEasyShipShipmentClearState]: () => initialState,

});

export default postEasyShipBuyShipmentReducer;
